import { render, staticRenderFns } from "./duplicatePoint.vue?vue&type=template&id=077a7dfd&scoped=true"
import script from "./duplicatePoint.vue?vue&type=script&lang=js"
export * from "./duplicatePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077a7dfd",
  null
  
)

export default component.exports